import React, { FC } from "react";

import { CloseButton } from "../../CloseButton/CloseButton";
import ClickAwayListener from "react-click-away-listener";
import { useHandleClickAway } from "../../Hooks/useHandleClickAway";
import classNames from "classnames";

type AgeValidationModalProps = {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
  description: string|undefined;
  Modal: any;
};

export const AgeValidationModal: FC<AgeValidationModalProps> = ({
  onConfirm,
  onClose,
  isOpen,
  Modal,
  description,
}) => {
  const {
    handleMouseUp,
    handleMouseDown,
    handleClickAway,
    areaRef,
  } = useHandleClickAway(onClose);

  return (
    <Modal
      overlayClassName="react-modal__overlay"
      className={classNames("react-modal__content react-modal__content--additional", { 'react-modal__content--opened': isOpen })}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <div className="confirm-modal__outer">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className="confirm-modal__inner my-2 p-2 pt-1 fs-5" ref={areaRef} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}>
            <CloseButton onClick={onClose} withWhiteBg />
            {description}
            <div className="d-flex justify-content-center mt-2">
              <button className="btn btn-primary" onClick={onConfirm}>
                Fortsett
              </button>
            </div>
          </div>
        </ClickAwayListener>
      </div>
    </Modal>
  );
};
